import * as React from 'react';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import './LiveFeed.css';
import { Icon } from 'antd';

function LiveFeed({ src }) {
  const canvasRef = React.useRef(null);
  const canvasWrapper = React.useRef(null);
  const image = React.useRef(null);
  const [max, setMax] = React.useState(false);

  React.useEffect(() => {
    image.current = new Image();
    image.current.src = src;
    const { clientWidth, clientHeight } = canvasWrapper.current;
    const canvas = canvasRef.current;
    image.current.onload = () => {
      const fitScale = Math.max(
        image.current.naturalWidth / clientWidth,
        image.current.naturalHeight / clientHeight
      );
      const [iw, ih] = [
        image.current.naturalWidth / fitScale || 0,
        image.current.naturalHeight / fitScale || 0,
      ];
      canvas.width = iw;
      canvas.height = ih;
      const context = canvas.getContext('2d');
      context.drawImage(image.current, 0, 0, ih, iw);
    };
  }, [src, max]);
  return (
    <Draggable axis="both" bounds="html" disabled={max}>
      <div ref={canvasWrapper} className={`feed ${max && 'streamingMax'}`}>
        <Icon
          type={max ? 'shrink' : 'arrows-alt'}
          className="streamingMaxBtn"
          onClick={(e) => {
            setMax((prevMax) => !prevMax);
            e.stopPropagation();
          }}
        />
        <div className="liveIndicator" />
        <canvas ref={canvasRef} />
      </div>
    </Draggable>
  );
}

LiveFeed.defaultProps = {
  src: '',
};

LiveFeed.propTypes = {
  src: PropTypes.string,
};

export default LiveFeed;
